
export const DEFAULT_PHONE = '0000000001';